import script from "./CameraView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CameraView.vue?vue&type=script&setup=true&lang=ts"

import "./CameraView.vue?vue&type=style&index=0&id=179383cc&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-179383cc"]])

export default __exports__